import { isEmpty } from 'lodash';
import {
    validateError,
    ErrorAPICode,
    ErrorAPIReasons,
    ErrorAPIMessages,
    ErrorAPIErrors,
    errorMap,
} from '../../error/error_map';

const options = {
    errorMap: { ...errorMap },
    reasons: { ...ErrorAPIReasons },
    codes: { ...ErrorAPICode },
    messages: { ...ErrorAPIMessages },
    errors: { ...ErrorAPIErrors },
};

/* Friendly titles for known Connect backend error codes (message keeps the API text). */
const TITLE_BY_ERROR = {
    INSUFFICIENT_ACCESS_PRIVILEGE: 'Not subscribed to Connect',
};

export function serviceErrorSerializer (errors) {
    if (isEmpty(errors)) {
        return {};
    }
    const raw = errors[0] || {};

    /*
     * Let the shared mapper handle session/auth/known errors first
     * (e.g. INVALID_ACCESS_TOKEN -> generic dialog + sign-out).
     */
    const mapped = validateError(raw, options);
    if (!isEmpty(mapped)) {
        return mapped;
    }

    /*
     * Fallback: surface the actual backend message instead of the generic
     * "Oops! Something went wrong." so the user sees the real reason.
     */
    const message = raw.message || raw.error || 'Something went wrong. Please try again.';
    return {
        title: TITLE_BY_ERROR[raw.error] || 'Connect error',
        message: message.charAt(0).toUpperCase() + message.slice(1),
    };
}
